import { z } from 'zod'

export const socialLinksSchema = z.object({
  youtube: z
    .url('Please enter a valid URL')
    .refine(
      (url) => /^https:\/\/(www\.)?youtube\.com\//.test(url) || url.startsWith('https://youtu.be/'),
      'URL must start with https://(www.)youtube.com/ or https://youtu.be/',
    )
    .optional()
    .or(z.literal('')),
  x: z
    .url('Please enter a valid URL')
    .refine(
      (url) => /^https:\/\/(www\.)?(x|twitter)\.com\//.test(url),
      'URL must start with https://(www.)x.com/ or https://(www.)twitter.com/',
    )
    .optional()
    .or(z.literal('')),
  discord: z
    .url('Please enter a valid URL')
    .refine(
      (url) => /^https:\/\/(www\.)?discord\.(com|gg)\//.test(url),
      'URL must start with https://(www.)discord.com/ or https://(www.)discord.gg/',
    )
    .optional()
    .or(z.literal('')),
  facebook: z
    .url('Please enter a valid URL')
    .refine(
      (url) => /^https:\/\/(www\.)?facebook\.com\//.test(url),
      'URL must start with https://(www.)facebook.com/',
    )
    .optional()
    .or(z.literal('')),
  instagram: z
    .url('Please enter a valid URL')
    .refine(
      (url) => /^https:\/\/(www\.)?instagram\.com\//.test(url),
      'URL must start with https://(www.)instagram.com/',
    )
    .optional()
    .or(z.literal('')),
  bluesky: z
    .url('Please enter a valid URL')
    .startsWith('https://bsky.app/', 'URL must start with https://bsky.app/')
    .optional()
    .or(z.literal('')),
})

export const socialLinkSchema = z.object({
  key: socialLinksSchema.keyof(),
  value: z.string(),
})

/** Keeps only the `social_links` entries the profile UI can render; the CMS API does not enforce their shape. */
export function parseSocialLinks(raw: unknown): z.infer<typeof socialLinkSchema>[] {
  if (!Array.isArray(raw)) return []

  return raw.flatMap((entry) => {
    const result = socialLinkSchema.safeParse(entry)
    return result.success ? [result.data] : []
  })
}

export const MAX_BIO_LENGTH = 4096

export const formSchema = z.object({
  bio: z.string().max(MAX_BIO_LENGTH, `Bio must be less than ${MAX_BIO_LENGTH} characters`),
  socialLinks: socialLinksSchema,
  enableSocialLinks: z.boolean(),
})

export type FormSchema = z.infer<typeof formSchema>
